module.exports = __webpack_public_path__ + "img/Weapon_217.05f392b0.png";